import { render, staticRenderFns } from "./firewall.vue?vue&type=template&id=d147a5e0&"
import script from "./firewall.vue?vue&type=script&lang=js&"
export * from "./firewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports